import { useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";
import { memo } from "react";

type DeleteDialog = {
  isOpen: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
};

const DeleteDialog = memo(
  ({ isOpen, handleClose, handleConfirm }: DeleteDialog) => {
    const { l10n } = useLocalization();

    return (
      <Dialog
        isOpen={isOpen}
        onUserDismiss={handleClose}
        title={l10n.getString("delete-alert-modal-title", {}, "Delete alert")}
        footer={
          <Row justifyContent="end" alignItems="center">
            <Row.Item shrink>
              <Button
                kind="plain"
                label={l10n.getString("button-cancel", {}, "Cancel")}
                type="button"
                onClick={handleClose}
              />
            </Row.Item>
            <Row.Item shrink>
              <Button
                kind="primary"
                label={l10n.getString(
                  "delete-alert-modal-confirm-button",
                  {},
                  "Yes, delete"
                )}
                type="button"
                onClick={handleConfirm}
              />
            </Row.Item>
          </Row>
        }
      >
        {l10n.getString(
          "delete-alert-modal-content",
          {},
          "Are you sure you want to delete this alert?"
        )}
      </Dialog>
    );
  }
);

export default DeleteDialog;
